/*       */

import { gql } from '@apollo/client';
import entitiesListShortCommonQuery from 'graphql/entities/common/entitiesListShortCommonQuery';

export default gql`
    query organisationsListShortQuery($startIndex: Int, $stopIndex: Int, $filterBy: [JSON], $orderBy: [JSON], $excludeBy: [JSON]) {
        count: count(dataType: "organisation", filterBy: $filterBy, excludeBy: $excludeBy)
        records: organisations(startIndex: $startIndex, stopIndex: $stopIndex, filterBy: $filterBy, orderBy: $orderBy, excludeBy: $excludeBy) {
            ${entitiesListShortCommonQuery}
        }
    }
`;
